import { AnimatePresence, motion } from 'framer-motion'
import { isArray, isEmpty } from 'lodash'
import React, { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import { connect, useDispatch, useSelector } from 'react-redux'

import {
  mudarFiltros,
  realizouFiltro,
  revelarBarraFiltragem
} from '../../../redux/actions/index'
import { useGlobal } from '../../../stores/useGlobal'
import {
  fecharBarraFiltro,
  fecharJanela
} from '../../../utils/alternanciaIcones'
import '../../../css/componentesModais/barraFiltragem/barraFiltragem.css'

let nomeCampoFiltro = []
const objFiltroVazio = { vazio: 'vazio' }

const TYPE_FILTERS = ['WhiteChip', 'Operator', 'ESim']
const HAS_ZUSTAND_FILTER = [
  'USUARIO_VENDEDOR',
  'USUARIO_COM_CONTA_SMS',
  'MOTIVO_INATIVACAO',
  'STATUS_USUARIO'
]

const limparCamposVazios = (obj) =>
  Object.fromEntries(
    Object.entries(obj).filter(
      ([_, value]) => value !== '' && value !== null && value !== undefined
    )
  )

const slideFromTop = {
  initial: { opacity: 0, y: -10 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -10 },
  transition: { duration: 0.3 }
}

const slideFromShow = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.3 }
}

function BarraFiltragem({ revelarBarraFiltro }) {
  const {
    filtros: filtrosZustand,
    setFiltros: setFiltrosZustand,
    setRevelarBarraFiltro: setRevelarBarraFiltroZustand
  } = useGlobal()

  const despacho = useDispatch()
  let filtrosArrayBarra = useSelector(
    (state) => state.filtrosState.filtrosArrayBarra
  )
  let filtros = useSelector((state) => state.filtrosState.filtros)
  let recarregarBarraFiltragem = useSelector(
    (state) => state.filtrosState.recarregarBarraFiltragem
  )

  const manejador = useSelector((state) => state.manejadorState.manejador)

  let cont = 0
  let temporarioFiltro = JSON.parse(JSON.stringify(filtros))

  const filtroMap = {
    CONEXOES_MIN: { CONEXOES_MIN: '', CONEXOES_MAX: '', CONEXOES: '' },
    PACOTES_MIN: { PACOTES_MIN: '', PACOTES_MAX: '', PACOTES: '' },
    ULTIMA_CONEXAO_INICIO: {
      ULTIMA_CONEXAO_INICIO: '',
      ULTIMA_CONEXAO_FINAL: ''
    },
    DtRequisicaoInicio: { DtRequisicaoInicio: '', DtRequisicaoFim: '' },
    CicloEfetivacaoInicio: {
      CicloEfetivacaoInicio: '',
      CicloEfetivacaoFim: ''
    },
    PLanoCliente: { PLanoClienteInicio: '', PLanoClienteFim: '' },
    PlanoOperadora: { PlanoOperadoraInicio: '', PlanoOperadoraFim: '' },
    ConsumoCicloAnterior: {
      ConsumoCicloAnteriorInicio: '',
      ConsumoCicloAnteriorFim: ''
    },
    ConsumoConsiderado: {
      ConsumoConsideradoInicio: '',
      ConsumoConsideradoFim: ''
    },
    CONSUMO_MIN: { CONSUMO_MIN: '', CONSUMO_MAX: '', CONSUMO: '' },
    VALOR_MIN: { VALOR_MIN: '', VALOR_MAX: '' },
    DIAS_USADOS_MIN: { DIAS_USADOS_MIN: '', DIAS_USADOS_MAX: '' },
    AQUISICAO_INICIO: { AQUISICAO_INICIO: '', AQUISICAO_FINAL: '' },
    ATIVACAO_INICIO: { ATIVACAO_INICIO: '', ATIVACAO_FINAL: '' },
    SALDO_MIN: { SALDO_MIN: '', SALDO_MAX: '' },
    RANGE_ICCID_MIN: { RANGE_ICCID_MIN: '', RANGE_ICCID_MAX: '' }
  }

  const [haveFiltros, setHaveFiltros] = useState(false)
  const [tagsExtras, setTagsExtras] = useState([])
  const [monitorarOperadora, setMonitorarOperadora] = useState(false)
  const [monitorarFiltros, setMonitorarFiltros] = useState(false)

  useEffect(() => {
    // temFiltros(filtrosArrayBarra.length)
    let barraPrincipal
    let larguraBarraPrincipal
    let larguraBarraTag
    let tag
    let total
    //pega a largura da barra principal
    if (document.getElementById('elemento-principal')) {
      barraPrincipal = document.getElementById('elemento-principal')
      larguraBarraPrincipal = barraPrincipal.clientWidth
    }
    if (document.getElementById('meu-elemento')) {
      tag = document.getElementById('meu-elemento')
      larguraBarraTag = tag.clientWidth
    }
    //transforma em percentual a largura da div que contem as tags
    if (larguraBarraPrincipal && larguraBarraTag) {
      let percentual = larguraBarraTag * 100
      total = percentual / larguraBarraPrincipal
      total = Math.round(total)
    }
    countTags()
    if (total >= 50) {
      setHaveFiltros(true)
    } else {
      setHaveFiltros(false)
    }
    countTags()
  }, [recarregarBarraFiltragem, monitorarFiltros, monitorarOperadora])

  //! comentado pois estava causando um bug, testei e nao consegui ver onde isso afeta
  // useEffect(() => {
  // return () => {
  //   if (JSON.stringify(filtros).includes("ICCID")) return;
  //   despacho(mudarFiltros(objFiltroVazio));
  //   despacho(revelarBarraFiltragem(false));
  //   despacho(realizouFiltro(false));
  // };
  // }, [filtros]);

  function countTags() {
    const divGeral = document.getElementById('meu-elemento')
    if (divGeral) {
      let countMaxWidth = 0
      let divsOverflow = 0
      // pega a largura de cada tag de filtros dentro da div
      // se caso a somatoria do tamanho de todas as tags forem maior que a div que compõem as tags
      // o botão de abrir a modal de filtros será ativado ocultando o restante de filtros que ficaram de fora da tela
      const allDivs = divGeral.querySelectorAll('.barra-filtragem-caixa')
      for (const el of allDivs) {
        countMaxWidth += el.offsetWidth + 17.5
        if (countMaxWidth > divGeral.offsetWidth) {
          divsOverflow += 1
        }
      }
      setTagsExtras(divsOverflow)
      if (divsOverflow <= 0) {
        setHaveFiltros(false)
      }
    }
  }

  function removerIdDoCampo(auxfiltros, campo, id) {
    if (auxfiltros[campo]) {
      auxfiltros[campo] = auxfiltros[campo]
        .split(',')
        .filter((item) => item !== id)
        .join(',')
    }
  }

  function removerIdDoCampoCidade(auxfiltros, id) {
    if (auxfiltros.CIDADE) {
      auxfiltros.CIDADE = auxfiltros.CIDADE.filter(
        (item) => item.value !== Number(id)
      )
    }
  }

  function handlerDeleteLastFiltro(id, i, tipoFiltro) {
    let getTipoFiltro = []
    let idOperadora = []
    let numberArr = []
    idOperadora.push(id)
    numberArr.push(parseInt(idOperadora[0]))

    if (tipoFiltro === 'REDE') {
      temporarioFiltro = JSON.parse(JSON.stringify(filtros))

      getTipoFiltro.push(filtros[tipoFiltro].split(','))

      let removeTipoFiltroOpcao = getTipoFiltro[0].filter(
        (item) => item !== id.split('?')[0]
      )

      removeFiltro(i)

      delete temporarioFiltro[tipoFiltro]

      temporarioFiltro[tipoFiltro] = removeTipoFiltroOpcao.join(',')

      despacho(mudarFiltros(removeEmptyProperties(temporarioFiltro)))

      return
    }

    if (HAS_ZUSTAND_FILTER.includes(tipoFiltro)) {
      const auxfiltros = { ...filtrosZustand }
      const filtrosParaRemover = {
        MOTIVO_INATIVACAO: ['cd_pav_usuario_bloqueio_status'],
        STATUS_USUARIO: ['fl_ativo'],
        USUARIO_COM_CONTA_SMS: ['userHasSMS'],
        USUARIO_VENDEDOR: ['fl_vendedor']
      }

      const campos = filtrosParaRemover[tipoFiltro] || []
      campos.forEach((campo) => delete auxfiltros[campo])

      const auxfiltrosLimpos = limparCamposVazios(auxfiltros)

      removeFiltro(i)
      setFiltrosZustand(auxfiltrosLimpos)

      countTags()
      return
    }

    if (tipoFiltro && TYPE_FILTERS.some((key) => tipoFiltro.includes(key))) {
      const auxfiltros = { ...filtrosZustand }
      const camposParaRemover = {
        classificacaoRedeOperator: () =>
          removerIdDoCampo(auxfiltros, 'TIPO', id),
        operadoraOperator: () => removerIdDoCampo(auxfiltros, 'OPERADORA', id),
        tecnologiaOperator: () =>
          removerIdDoCampo(auxfiltros, 'TECNOLOGIA', id),
        estadoOperator: () => removerIdDoCampo(auxfiltros, 'ESTADO', id),
        cidadeOperator: () => removerIdDoCampoCidade(auxfiltros, id),
        idPortadoraOperator: () => delete auxfiltros.ID_PORTADORA,
        carrierWhiteChip: () => removerIdDoCampo(auxfiltros, 'CdOperadora', id),
        statusWhiteChip: () => removerIdDoCampo(auxfiltros, 'CdStatus', id),
        userWhiteChip: () => removerIdDoCampo(auxfiltros, 'CdUsuario', id),
        planWhiteChip: () => removerIdDoCampo(auxfiltros, 'CdPlano', id),
        preActivationWhiteChip: () => delete auxfiltros.PrazoPreAtivacao,
        acquisitionDateWhiteChip: () => {
          delete auxfiltros.DataAquisicaoInicio
          delete auxfiltros.DataAquisicaoFim
        },
        provisioningWhiteChip: () => {
          delete auxfiltros.DataDeProvisionamentoInicio
          delete auxfiltros.DataDeProvisionamentoFim
        },
        preProvisioningWhiteChip: () => {
          delete auxfiltros.PreProvisionamentoInicio
          delete auxfiltros.PreProvisionamentoFim
        },
        iccidWhiteChip: () => {
          delete auxfiltros.IccidInicial
          delete auxfiltros.IccidFinal
        },
        eidESim: () => delete filtros.CD_ESIM, //Filtro nao pertence ao zustand
        carrierESim: () => removerIdDoCampo(auxfiltros, 'CARRIER', id),
        customerESim: () => removerIdDoCampo(auxfiltros, 'CUSTOMER', id),
        offerESim: () => removerIdDoCampo(auxfiltros, 'OFFER', id),
        profileESim: () => removerIdDoCampo(auxfiltros, 'PROFILE', id),
        statusESim: () => removerIdDoCampo(auxfiltros, 'STATUS', id),
        lastUpdateESim: () => {
          delete auxfiltros.LASTUPDATESTART
          delete auxfiltros.LASTUPDATEEND
        }
      }

      if (camposParaRemover[tipoFiltro]) camposParaRemover[tipoFiltro]()
      const auxfiltrosLimpos = limparCamposVazios(auxfiltros)
      removeFiltro(i)

      if (tipoFiltro === 'eidESim') {
        despacho(mudarFiltros(removeEmptyProperties(filtros)))
        return
      }

      setFiltrosZustand(auxfiltrosLimpos)
      countTags()
      return
    }

    if (numberArr[0] > 0 && tipoFiltro && tipoFiltro !== 'REDE') {
      temporarioFiltro = JSON.parse(JSON.stringify(filtros))
      // caso o usuario feche uma tag de operadora na barra de dispositivos ou solicitações/conectividade
      getTipoFiltro.push(filtros[tipoFiltro].split(','))
      let removeTipoFiltroOpcao = getTipoFiltro[0].filter(function (objeto) {
        return idOperadora[0].indexOf(objeto) == -1
      })
      removeFiltro(i)
      delete temporarioFiltro[tipoFiltro]
      temporarioFiltro[tipoFiltro] = removeTipoFiltroOpcao.join(',')
      despacho(mudarFiltros(removeEmptyProperties(temporarioFiltro)))

      if (tipoFiltro === 'OPERADORA') {
        let arr = temporarioFiltro?.CdOperadora?.split(',')
        if (arr) {
          arr = arr?.filter((num) => num != id)
          temporarioFiltro.CdOperadora = arr.join(arr?.length ? ',' : '')
          filtrosArrayBarra.filter((f) => f.trim() !== `NEO ${id}`)
        }

        setMonitorarOperadora(temporarioFiltro[tipoFiltro])
      }
    } else {
      let TemporarioValor = ''
      let TemporarioData = ''

      id[0].split('_').map((item_id) => {
        //caso para o grupo de input, onde verifica se tem tais terminacoes e deleta o valor maximo
        if (item_id == 'MIN' || item_id == 'MAX') {
          TemporarioValor += '_MAX'
          //retira o primeiro dash
          TemporarioValor = TemporarioValor.replace('_', '')
          //caso especial onde e necessario resetar outro elemento
          if (TemporarioValor == 'CONSUMO_MAX') temporarioFiltro['CONSUMO'] = ''
          if (TemporarioValor == 'CONEXOES_MAX')
            temporarioFiltro['CONEXOES'] = ''
          if (TemporarioValor == 'PACOTES_MAX') temporarioFiltro['PACOTES'] = ''
          //reseta o valor
          temporarioFiltro[TemporarioValor] = ''
        } else {
          TemporarioValor += '_' + item_id
        }

        //caso para o calendario, onde verifica se tem tais terminacoes e deleta a data final
        if (item_id == 'INICIO' || item_id == 'FINAL') {
          TemporarioData += '_FINAL'
          //retira o primeiro dash
          TemporarioData = TemporarioData.replace('_', '')

          //caso especial onde e necessario resetar outro elemento
          // if(TemporarioData == "ULTIMA_CONEXAO_FINAL") temporarioFiltro['ULTIMA_CONEXAO'] = ''
          //reseta o valor
          temporarioFiltro[TemporarioData] = ''
        } else {
          TemporarioData += '_' + item_id
        }
      })

      //reseta o valor
      if (id && filtroMap[id]) {
        removeFiltro(i, filtroMap[id])
      } else if (tipoFiltro === 'StatusMigracao') {
        const arrStatusM = temporarioFiltro?.StatusMigracao?.split(',') || []
        if (!arrStatusM.length) return

        const newArrStatusMigracao = arrStatusM.filter((item) => item !== id)
        const StatusMigracao = newArrStatusMigracao.toString() || undefined
        removeFiltro(i, { StatusMigracao })
      } else {
        if (id === 'ds_pav_cidade' && isArray(temporarioFiltro[id])) {
          // * feito pra filtro de cidade da tela /veye/virtueyes/virtuClientes
          const cidadeParaRemover = filtrosArrayBarra[i]
          let cidadeEstado = ''

          if (cidadeParaRemover.startsWith('Cidade:')) {
            cidadeEstado = cidadeParaRemover
              .split('?')[0]
              .replace('Cidade: ', '')
          }

          temporarioFiltro[id] = temporarioFiltro[id].filter(
            (item) => item.label !== cidadeEstado
          )

          removeFiltro(i)

          return
        }

        if (
          temporarioFiltro[id] &&
          typeof temporarioFiltro[id] !== 'number' &&
          temporarioFiltro[id].includes(',')
        ) {
          const valores = temporarioFiltro[id].split(',')
          if (valores.length > 1) {
            const valorParaRemover = valores[i]
            const novosValores = valores.filter(
              (valor) => valor !== valorParaRemover
            )
            temporarioFiltro[id] = novosValores.join(',')
          } else {
            temporarioFiltro[id] = ''
          }
        } else {
          temporarioFiltro[id] = ''
        }

        if (manejador === 'dashboardGeral' && id === 'OPERADORA_PLANO') {
          temporarioFiltro.DS_OPERADORA_PLANO = ''
          temporarioFiltro.LINHAS = ''
          temporarioFiltro.PLANO_TIPO = ''
        }

        const auxRemoverFiltro =
          id === 'CD_SITUACAO' ? { STATUS_CONTRATO: '' } : undefined

        removeFiltro(i, auxRemoverFiltro)

        temporarioFiltro = removeEmptyProperties(temporarioFiltro)

        if (isEmpty(temporarioFiltro)) {
          temporarioFiltro = objFiltroVazio
        }

        despacho(mudarFiltros(temporarioFiltro))

        const hasFilters = Object.keys(filtrosZustand)?.length > 0
        if (hasFilters) {
          const auxFilter = { ...filtrosZustand }
          delete auxFilter[`${id}`]
          setFiltrosZustand(auxFilter)
        }
      }
    }
    countTags()
  }

  function removeFiltro(index, fields) {
    if (fields) {
      Object.entries(fields).forEach(([key, value]) => {
        temporarioFiltro[key] = value
      })
    }
    filtrosArrayBarra.splice(index, 1)
    despacho(mudarFiltros(temporarioFiltro))
    setMonitorarFiltros(temporarioFiltro)

    if (filtrosArrayBarra.length === 0) {
      setRevelarBarraFiltroZustand(false)
      despacho(revelarBarraFiltragem(false))
    }
  }

  function removeEmptyProperties(obj) {
    return Object.fromEntries(Object.entries(obj).filter(([, v]) => v !== ''))
  }

  useEffect(() => {
    if (filtrosArrayBarra.length === 0) {
      setRevelarBarraFiltroZustand(false)
      despacho(revelarBarraFiltragem(false))
    }
  }, [filtrosArrayBarra, despacho, setRevelarBarraFiltroZustand])

  function renderFiltros() {
    nomeCampoFiltro = []
    let contagem = 0
    let comOperadora = false

    filtrosArrayBarra.map(function (item) {
      if (!item.includes('?')) {
        contagem++
      }
    })
    if (contagem >= 0) {
      comOperadora = true
    }

    return (
      <AnimatePresence>
        {filtrosArrayBarra.map(function (item, i) {
          if (
            item.includes('?') &&
            ((manejador !== 'dashboardGeral' && !item.includes('Rede')) ||
              manejador === 'dashboardGeral')
          ) {
            const valor = item.split('?')
            nomeCampoFiltro.push(valor[1].split(','))
            if (cont === 0) {
              cont++
              return (
                <React.Fragment key={'tag-' + valor[0]}>
                  <motion.div
                    id={'tag-' + valor[0]}
                    className="barra-filtragem-caixa"
                    {...slideFromShow}
                  >
                    <div id="testeBox" className="filtragem-caixa">
                      <span className="fonte-barra-filtro">{valor[0]}</span>
                      <Button
                        className="botao-remover-filtro"
                        variant="danger"
                        onClick={() => handlerDeleteLastFiltro(valor[1], i)}
                      >
                        <img
                          className="botao-limpar-item-icone"
                          src={fecharBarraFiltro()}
                          alt="fechar-janela"
                        />
                      </Button>
                    </div>
                  </motion.div>
                </React.Fragment>
              )
            } else if (filtrosArrayBarra.length == i + 1) {
              return (
                <React.Fragment key={'tag-' + valor[0]}>
                  <motion.div
                    id={'tag-' + valor[0]}
                    className="barra-filtragem-caixa"
                    {...slideFromShow}
                  >
                    <div className="filtragem-caixa">
                      <span className="fonte-barra-filtro">{valor[0]}</span>
                      <Button
                        className="botao-remover-filtro"
                        variant="danger"
                        onClick={() =>
                          comOperadora
                            ? handlerDeleteLastFiltro(valor[1], i)
                            : handlerDeleteLastFiltro(nomeCampoFiltro[i], i)
                        }
                      >
                        <img
                          className="botao-limpar-item-icone"
                          src={fecharBarraFiltro()}
                          alt="fechar-janela"
                        />
                      </Button>
                    </div>
                  </motion.div>
                </React.Fragment>
              )
            } else {
              return (
                <React.Fragment key={'tag-' + valor[0]}>
                  <motion.div
                    id={'tag-' + valor[0]}
                    className="barra-filtragem-caixa"
                    {...slideFromShow}
                  >
                    <div className="filtragem-caixa">
                      <span className="fonte-barra-filtro">{valor[0]}</span>
                      <Button
                        className="botao-remover-filtro"
                        variant="danger"
                        onClick={() => handlerDeleteLastFiltro(valor[1], i)}
                      >
                        <img
                          className="botao-limpar-item-icone"
                          src={fecharBarraFiltro()}
                          alt="fechar-janela"
                        />
                      </Button>
                    </div>
                  </motion.div>
                </React.Fragment>
              )
            }
          } else if (TYPE_FILTERS.some((key) => item.includes(key))) {
            let auxItem = item.split(': ')[1] || ''
            const tiposDeFiltro = {
              statusWhiteChip: 'Status',
              planWhiteChip: 'Plano',
              preActivationWhiteChip: 'Prazo pré-ativação',
              preProvisioningWhiteChip: 'Pré-provisionamento',
              acquisitionDateWhiteChip: 'Aquisição',
              provisioningWhiteChip: 'Data de provisionamento',
              iccidWhiteChip: 'ICCID entre',
              carrierWhiteChip: 'Operadora',
              userWhiteChip: 'Usuário',
              estadoOperator: 'Estado',
              cidadeOperator: 'Cidade',
              tecnologiaOperator: 'Tecnologia',
              operadoraOperator: 'Rede',
              idPortadoraOperator: 'ID Portadora',
              classificacaoRedeOperator: 'Classificação da Rede',
              eidESim: 'e-SIMs',
              lastUpdateESim: 'Última atualização',
              customerESim: 'Cliente',
              offerESim: 'Oferta',
              profileESim: 'Perfil',
              statusESim: 'Status',
              carrierESim: 'Operadora'
            }

            const tipoFiltro =
              Object.keys(tiposDeFiltro).find((key) => item.includes(key)) || ''

            const descricao = tiposDeFiltro[tipoFiltro] || ''

            const [valor, codigo] = auxItem.split('_').filter(Boolean)
            const titulo = descricao ? `${descricao}: ${valor}` : ''

            return (
              <motion.div
                key={`tag-${titulo}`}
                id={`tag-${titulo}`}
                className="barra-filtragem-caixa"
                {...slideFromShow}
              >
                <div className="filtragem-caixa">
                  <span className="fonte-barra-filtro">{titulo}</span>
                  <Button
                    className="botao-remover-filtro"
                    variant="danger"
                    onClick={() =>
                      handlerDeleteLastFiltro(codigo, i, tipoFiltro)
                    }
                  >
                    <img
                      className="botao-limpar-item-icone"
                      src={fecharBarraFiltro()}
                      alt="fechar-janela"
                    />
                  </Button>
                </div>
              </motion.div>
            )
          } else {
            //OS IFs ABAIXO SÃO APENAS PARA VALIDAR CHAMADAS ESPECIFICAS EM DISPOSITIVOS OU SOLICITAÇÕES/CONECTIVIDADE
            let auxItem = item
            let tipoFiltro = 'OPERADORA'

            const filtroPorRede = auxItem.includes('Rede: ')
            const filtroPorStatus = auxItem.includes('Status: ')
            const filtroPorStatusMigracao =
              auxItem.includes('Status migração: ')
            const filtroPorStatusUsuario = auxItem.includes('Status Usuário:')
            const filtroPorUsuarioVendedor =
              auxItem.includes('Usuário vendedor:')
            const filtroPorUsuarioComContaSMS = auxItem.includes(
              'Usuário com conta SMS:'
            )
            const filtroPorMotivoInativacao = auxItem.includes(
              'Motivo da inativação: '
            )
            const filtroPorOperadoraPlano = auxItem.includes('Operadora Plano:')

            if (filtroPorStatus) {
              auxItem = auxItem.split(': ')[1]
              tipoFiltro = 'STATUS'
            } else if (filtroPorStatusMigracao) {
              auxItem = auxItem.split(': ')[1]
              tipoFiltro = 'StatusMigracao'
            } else if (filtroPorRede) {
              auxItem = auxItem.split(': ')[1]
              tipoFiltro = 'REDE'
            } else if (filtroPorMotivoInativacao) {
              auxItem = auxItem.split(': ')[1]
              tipoFiltro = 'MOTIVO_INATIVACAO'
            } else if (filtroPorStatusUsuario) {
              auxItem = auxItem.split(': ')[1]
              tipoFiltro = 'STATUS_USUARIO'
            } else if (filtroPorUsuarioVendedor) {
              auxItem = auxItem.split(': ')[1]
              tipoFiltro = 'USUARIO_VENDEDOR'
            } else if (filtroPorUsuarioComContaSMS) {
              auxItem = auxItem.split(': ')[1]
              tipoFiltro = 'USUARIO_COM_CONTA_SMS'
            } else if (filtroPorOperadoraPlano) {
              auxItem = auxItem.split(': ')[1]
              tipoFiltro = 'OPERADORA_PLANO'
            }

            /* 
          apenas para checkbox nas telas:
          operadora em disositivos e Status 
          e Operadora em solicitações/conectividade
        */

            const valor = auxItem.split(' ')
            let resultado = valor.filter((v) => v !== '')
            let codigo = resultado[resultado.length - 1]
            let titulo = valor.length === 3 ? valor[1] : valor[0]

            if (filtroPorStatusMigracao) {
              if (titulo === 'Sem') titulo = 'Sem migração'
              codigo = titulo
              titulo = `Status migração: ${titulo}`
            } else if (filtroPorStatus) {
              titulo = `Status: ${titulo}`
            } else if (tipoFiltro === 'OPERADORA') {
              const operadorasNeo = ['NEO (Rede Vivo)', 'NEO (Rede Claro)']
              const operadoraNeoEncontrada = operadorasNeo.find((operadora) =>
                auxItem.includes(operadora)
              )

              if (operadoraNeoEncontrada) {
                const textoFormatado = auxItem.replace(codigo, '').trim()
                titulo = `Operadora: ${textoFormatado}`
              } else {
                titulo = `Operadora: ${titulo}`
              }
            } else if (tipoFiltro === 'REDE') {
              const splited = item.split('?')[0]
              const parts = splited.split(' ')
              const codigo = parts[parts.length - 1]
              titulo = splited.replace(codigo, '').trim()
            } else if (filtroPorMotivoInativacao) {
              titulo = `Motivo da inativação: ${auxItem}`
            } else if (tipoFiltro === 'STATUS_USUARIO') {
              titulo = `Status: ${auxItem}`
            } else if (tipoFiltro === 'USUARIO_VENDEDOR') {
              titulo = `Usuário vendedor: ${auxItem}`
            } else if (tipoFiltro === 'USUARIO_COM_CONTA_SMS') {
              titulo = `Conta SMS: ${auxItem}`
            } else if (tipoFiltro === 'OPERADORA_PLANO') {
              titulo = `Operadora Plano: ${auxItem}`
            }

            return (
              <motion.div
                key={`tag-${titulo}`}
                id={'tag-' + titulo}
                className="barra-filtragem-caixa"
                {...slideFromShow}
              >
                <div className="filtragem-caixa">
                  <span className="fonte-barra-filtro">{titulo}</span>
                  <Button
                    className="botao-remover-filtro"
                    variant="danger"
                    onClick={() =>
                      handlerDeleteLastFiltro(codigo, i, tipoFiltro)
                    }
                  >
                    <img
                      className="botao-limpar-item-icone"
                      src={fecharBarraFiltro()}
                      alt="fechar-janela"
                    />
                  </Button>
                </div>
              </motion.div>
            )
          }
        })}
      </AnimatePresence>
    )
  }

  return (
    <AnimatePresence>
      {revelarBarraFiltro && (
        <motion.div
          id="elemento-principal"
          key="barra-filtro"
          {...slideFromTop}
          className="barra-filtragem-cliente fundo-cor-5"
        >
          <p className="filtrado-por">Filtrado por: </p>
          <div id="meu-elemento" className="tags-barra-filtragem">
            {renderFiltros()}
          </div>

          <button className={haveFiltros ? 'mais-filtros' : 'menos-filtros'}>
            + {tagsExtras} Filtros
          </button>
          <div className="barra-filtragem-cliente-fechar fundo-cor-5">
            <div className="barra-filtragem-caixa-fechar">
              <p className="limpar-filtro">
                {filtrosArrayBarra.length > 1
                  ? 'LIMPAR FILTROS'
                  : 'LIMPAR FILTRO'}
              </p>
              <Button
                className="botao-remover-filtro"
                variant="danger"
                onClick={() => {
                  despacho(mudarFiltros(objFiltroVazio))
                  despacho(revelarBarraFiltragem(false))
                  despacho(realizouFiltro(true))
                  setFiltrosZustand(objFiltroVazio)
                  setRevelarBarraFiltroZustand(false)
                }}
              >
                <img
                  className="botao-fechar-janela-icone-barra-filtragem"
                  src={fecharJanela()}
                  alt="fechar-janela"
                />
              </Button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

function mapStateToProps(state) {
  return {
    filtrosArrayBarra: state.filtrosState.filtrosArrayBarra,
    recarregarBarraFiltragem: state.filtrosState.recarregarBarraFiltragem
  }
}

export default connect(mapStateToProps)(BarraFiltragem)
